import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
// import { Input, Button, Tooltip } from "antd";
import HotKeysModal from "Components/HotKeysModal";
import { updateAreaList, updateSelectCard, updateSelectArea } from "Store/ZoneSetting/action";
import { getItemtypeByDatatype, colorObj } from "./utilService";
import { GetQuery, langCheck } from "Pub/js/utils";
import { selectCardFromOther } from "./events";
import platform from 'Pub/js/platform';
const { getLangCode, base } = platform;
const { NCMultiLangText, NCFormControl } = base;
//添加非元数据模态框组件类
class AddNotMetaDataModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notMetaDataName: {},
            notMetaDataCode: "",
            explainForName: "",
            explainForCode: ""
        };
    }
    //设置新增非元数据模态框隐藏
    showModalHidden = () => {
        this.props.setAddDataModalVisibel(false);
        //弹窗关闭后需要清空弹窗数据
        this.setState({
            notMetaDataName: {},
            notMetaDataCode: "",
            explainForName: "",
            explainForCode: ""
        });
    };
    // 设置非元数据附件显示公式默认值
    // 公式的规则：accessorymath("[appcode][pagecode]/[areacode]]/[areaDataPrimaryFieldName]")
    // areaDataPrimaryFieldName当前区域对应的元数据主键
    genDefaultShowFormula() {
        let { zoneFormData, areaList, areaIndex } = this.props;
        let { code: areacode, metaid, areaDataPrimaryFieldName } = areaList[areaIndex];
        let { code, appcode, pagecode } = zoneFormData;
        let showformula = `accessorymath(${appcode}${pagecode}/${code}${areacode}/${areaDataPrimaryFieldName})`;
        return showformula;
    }
    /**
     * 当前语种返回字段显示名称多语信息
     * @returns {Object}
     */
    getCardLabel() {
        let { notMetaDataName } = this.state;
        let items = Object.entries(notMetaDataName).map(([key, el]) => {
            return [key, _.get(el, 'value')];
        });
        let ret = Object.fromEntries(items);
        return ret;
    }
    //点击确定按钮
    onOkDialog = () => {
        //确定之前先判断弹出框是否正确输入数据
        let flag = true;
        const { notMetaDataName, notMetaDataCode } = this.state;
        let { json, propperty, multiOptions } = this.props;
        if (this.checkDataCorrect(notMetaDataName).correct && this.checkDataCorrect(notMetaDataCode, "code").correct) {
            flag = false;
        }
        if (flag) {
            if (this.checkLocalEmpty(notMetaDataName)) {
                this.setState({
                    explainForName: langCheck("ZoneSetting-000000", "pages", json) /* 国际化处理： 不能为空*/
                });
            }
            if (notMetaDataCode == "") {
                this.setState({
                    explainForCode: langCheck("ZoneSetting-000000", "pages", json) /* 国际化处理： 不能为空*/
                });
            }
            return;
        }
        //
        let { areaList, areaIndex } = this.props;

        let { queryPropertyList } = areaList[areaIndex];
        let cardObj = {};
        let multiLangLabels = this.getCardLabel();
        const itemtype = getItemtypeByDatatype(propperty.datatype);
        if (this.props.areatype === "0") {
            //查询区
            cardObj = {
                pk_query_property: "newNotMetaData" + new Date().getTime(),
                areaid: areaList[areaIndex].pk_area,
                // label: this.state.notMetaDataName,
                ...multiLangLabels,
                code: this.state.notMetaDataCode,
                metapath: null,
                isnotmeta: true,
                isuse: true,
                position: `${queryPropertyList.length + 1}`,
                opersign: "=@>@>=@<@<=@like@",
                opersignname: langCheck(
                    "ZoneSetting-000001",
                    "pages",
                    json
                ) /* 国际化处理： 等于@大于@大于等于@小于@小于等于@相似@*/,
                defaultvalue: "",
                isfixedcondition: false,
                required: false,
                disabled: false,
                visible: true,
                ismultiselectedenabled: false,
                isquerycondition: false,
                datatype: propperty.datatype || "1",
                refname: "-99",
                containlower: false,
                ischeck: false,
                isbeyondorg: false,
                usefunc: false,
                showtype: "1",
                returntype: "refpk",
                define1: "",
                define2: "",
                define3: "",
                define4: "",
                define5: "",
                itemtype: itemtype || "input",
                visibleposition: "",
                tablecode: "",
                querytablename: ""
            };
        } else {
            //非查询区
            cardObj = {
                pk_query_property: "newNotMetaData" + new Date().getTime(),
                areaid: areaList[areaIndex].pk_area,
                code: this.state.notMetaDataCode,
                datatype: propperty.datatype || "1",
                // label: this.state.notMetaDataName,
                ...multiLangLabels,
                position: `${queryPropertyList.length + 1}`,
                metapath: null,
                color: colorObj() && colorObj()[0].value, //取常量中默认颜色
                isrevise: false,
                required: false,
                disabled: false,
                visible: true,
                maxlength: "20",
                defaultvalue: "",
                hyperlinkflag: false, //超链接
                defaultvar: "",
                define1: "",
                define2: "",
                define3: "",
                itemtype: itemtype || "input"
            };
            if (cardObj.datatype === "300") {
                cardObj.issupportphoto = false; //启用拍照模式
                cardObj.uploadquantity = ""; //上传张数
                cardObj.watermarktype = 0;//水印类型
                cardObj.watermarktext = "";//内容
                cardObj.watermarkfont = "";//字号
                cardObj.position = "";//位置
                cardObj.watermarkalpha = 0;//透明度
                cardObj.isshowtime = false;//显示地点
                cardObj.isshowplace = false;//显示时间

            }
        }
        // 非查询区 附件类型，设置显示公式的默认值
        // if (this.props.areatype !== '0' && itemtype === 'attachment' && cardObj.datatype === '300') {
        //     cardObj.showformula = this.genDefaultShowFormula();
        // }
        if (this.props.areatype === "1") {
            //表单
            cardObj.colnum = "1";
            cardObj.isnextrow = false;
        }
        if (this.props.areatype === "2") {
            //表格
            cardObj.width = "";
            cardObj.istotal = false;
        }

        if (propperty.dropIndex !== "") {
            areaList[areaIndex].queryPropertyList.splice(propperty.dropIndex, 0, cardObj);
        } else {
            areaList[areaIndex].queryPropertyList = queryPropertyList.concat(cardObj);
        }

        this.setState({
            // notMetaDataName: "",
            notMetaDataName: {},
            notMetaDataCode: "",
            explainForName: "",
            explainForCode: ""
        });
        this.props.updateAreaList(areaList);
        selectCardFromOther.call(this, cardObj); //选中添加的非元数据
        this.showModalHidden();
    };
    /**
     * 检查code是否已经存在，从而判断code唯一性
     * @param {String} checkCode 待检查的code文本
     * @return {Boolean} flag 是否存在/唯一
     */
    isUniqueInQueryList = checkCode => {
        let { areaList, areaIndex } = this.props;
        let queryPropertyList = areaList[areaIndex].queryPropertyList;
        let flag = true;
        _.forEach(queryPropertyList, q => {
            if (q.code === checkCode) {
                flag = false;
                return false;
            }
        });
        return flag;
    };
    checkLocalEmpty(value) {
        let { multiOptions } = this.props;
        let local = getLangCode('langCode');
        let items = Object.entries(value);
        let localValue = '';
        multiOptions.forEach(opt => {
            let { languageMain, index, languageCode } = opt;
            let itemKey = `label${index}`;
            if (languageCode === local) {
                localValue = _.get(value, `${itemKey}.value`, '');
            }
        });
        return localValue.length === 0;
    }
    /**
     * 检查数据是否正确
     * @param {String} checkedStr 待检查的文本
     * @param {String} type 待查文本的归属属性
     * @return {Object} 是否正确&错误数据提示
     */
    checkDataCorrect = (checkedStr, type) => {
        let correct = true;
        let errorMsg = "";
        let { json } = this.props;
        if (type === "code") {
            if (checkedStr === "") {
                errorMsg = langCheck("ZoneSetting-000000", "pages", json); /* 国际化处理： 不能为空*/
                correct = false;
            } else {
                //含中文正则
                let strRegExp = /[\u4e00-\u9fa5]/;
                if (strRegExp.test(checkedStr)) {
                    errorMsg = langCheck("ZoneSetting-000002", "pages", json); /* 国际化处理： 不能为中文*/
                    correct = false;
                }
                if (!this.isUniqueInQueryList(checkedStr)) {
                    errorMsg = langCheck("ZoneSetting-000003", "pages", json); /* 国际化处理： 不能编码重复*/
                    correct = false;
                }
            }
        } else {
            if (this.checkLocalEmpty(checkedStr)) {
                errorMsg = langCheck("ZoneSetting-000000", "pages", json); /* 国际化处理： 不能为空*/
                correct = false;
            }
        }
        return { correct: correct, errorMsg: errorMsg };
    };
    /**
     * 检查name和code都正确
     * @return {Boolean} 是否都正确
     */
    checkNameAndCodeCorrect = () => {
        let flag = false;
        const { notMetaDataName, notMetaDataCode } = this.state;
        if (this.checkDataCorrect(notMetaDataName).correct && this.checkDataCorrect(notMetaDataCode, "code").correct) {
            flag = true;
        }
        return flag;
    };
    //回车键事件
    onPressEnter = () => {
        if (!this.checkNameAndCodeCorrect()) {
            return;
        }
        this.onOkDialog();
    };
    //修改非元数据名称
    changeNotMetaDataName = value => {
        let newValue = _.clone(value);
        const { correct, errorMsg } = this.checkDataCorrect(newValue);
        this.setState({
            notMetaDataName: newValue,
            explainForName: errorMsg
        });
    }
    //修改非元数据编码
    changeNotMetaDataCode = e => {
        this.setState({ notMetaDataCode: e });
        const { correct, errorMsg } = this.checkDataCorrect(e, "code");
        this.setState({ explainForCode: errorMsg });
    };
    //当非元数据模态框状态，弹出时（状态由不显示=>显示），则文本框自动获得焦点
    // componentWillUpdate = (nextProps, nextState) => {
    //     if (!this.props.addDataModalVisibel && nextProps.addDataModalVisibel) {
    //         setTimeout(() => {
    //             this.refs.addNotMetaDataInputDom.focus();
    //         }, 0);
    //     }
    // };
    render() {
        let { json, multiOptions } = this.props;
        return (
            <HotKeysModal
                maskClosable={false}
                customHeader={langCheck("ZoneSetting-000004", "pages", json)} /* 国际化处理： 新增非元数据*/
                // mask={false}
                wrapClassName='add-not-meta-data'
                visible={this.props.addDataModalVisibel}
                okText={langCheck("ZoneSetting-000005", "pages", json)} /* 国际化处理： 确定*/
                cancelText={langCheck("ZoneSetting-000006", "pages", json)} /* 国际化处理： 取消*/
                onOk={this.onOkDialog}
                onCancel={this.showModalHidden}
                fieldid='addNotMeta'
                width={600}
                height={230}
            >
                <div
                    className='code-div'
                    ref='addNotMetaCodeDiv'
                >
                    {/* /* 国际化处理： 非元数据编码*/}
                    <span className="name">{langCheck("ZoneSetting-000007", "pages", json)}</span>
                    <div className="not-meta-content">
                        { /* 国际化处理： 请输入非元数据编码，非中文*/ }
                        <NCFormControl
                            autoFocus
                            placeholder={langCheck(
                                "ZoneSetting-000008",
                                "pages",
                                json
                            )}
                            value={this.state.notMetaDataCode}
                            onChange={this.changeNotMetaDataCode}
                            fieldid='notMetaCode'
                            maxlength={100}
                            isCheckChinese
                        />
                        {/* <Input
                            className={this.state.explainForCode === "" ? "" : "has-error"}
                            ref='addNotMetaDataInputDom'
                            placeholder={langCheck(
                                "ZoneSetting-000008",
                                "pages",
                                json
                            )}
                            value={this.state.notMetaDataCode}
                            onChange={this.changeNotMetaDataCode}
                            onPressEnter={this.onPressEnter}
                            fieldid='notMetaCode'
                            title={this.state.notMetaDataCode ? this.state.notMetaDataCode : langCheck(
                                "ZoneSetting-000008",
                                "pages",
                                json
                            )}
                        /> */}
                        <div
                            className='form-explain'
                            style={{
                                visibility: this.state.explainForCode === "" ? "hidden" : "visible"
                            }}
                        >
                            {this.state.explainForCode}
                        </div>
                    </div>
                </div>
                <div
                    ref='addNotMetaNameDiv'
                    className='not-code'
                >
                    {/* /* 国际化处理： 非元数据名称*/}
                    <span className="name">{langCheck("ZoneSetting-000009", "pages", json)}</span>
                    <div className="not-meta-content">
                        {/* <Input
                            className={this.state.explainForName === "" ? "" : "has-error"}
                            placeholder={langCheck(
                                "ZoneSetting-000010",
                                "pages",
                                json
                            )} 国际化处理： 请输入非元数据名称
                            value={this.state.notMetaDataName}
                            onChange={this.changeNotMetaDataName}
                            onPressEnter={this.onPressEnter}
                            fieldid='notMetaName'
                        /> */}
                        <NCMultiLangText
                            placeholder={langCheck(
                                "ZoneSetting-000010",
                                "pages",
                                json
                            )} // 国际化处理： 请输入非元数据名称
                            attrcode="label"
                            value={this.state.notMetaDataName}
                            onChange={this.changeNotMetaDataName}
                            onBlur={this.changeNotMetaDataName}
                            fieldid="notMetaName"
                            languageMeta={multiOptions}
                            maxlength={200}
                            isCheckChinese
                        />
                        <div
                            style={{
                                visibility: this.state.explainForName === "" ? "hidden" : "visible"
                            }}
                            className='form-explain'
                        >
                            {this.state.explainForName}
                        </div>
                    </div>
                </div>
            </HotKeysModal>
        );
    }
}
export default connect(
    state => ({
        areaList: state.zoneSettingData.areaList
    }),
    {
        updateAreaList,
        updateSelectCard,
        updateSelectArea
    }
)(AddNotMetaDataModal);
